import React from 'react';
import ColoredStatus from '../ColoredStatus/coloredStatus';
import styles from './retakeLinksStatus.module.css';

const RetakeLinksStatus = ({retakeLinksEnabled}) => {
    if (!retakeLinksEnabled) {
        return <></>
    }

    const retakeLinkStatus = 'Enabled';
    return (
      <div className={styles['retake-links']}>
        Retakes are <ColoredStatus status={retakeLinkStatus} translatedStatus={retakeLinkStatus} />
      </div>
    );
}

export default RetakeLinksStatus;